export const READ_MODE_OPTIONS = [
    { value: 'RAW', label: 'センサー値', tooltip: 'センサーが読み取ったアナログ値' },
    { value: 'PERCENT', label: '割合', tooltip: '0〜100の割合で表した数値 (%)' },
];

export const BRIGHTNESS_READ_MODE_OPTIONS = [
    { value: 'BRIGHTNESS', label: '明るさ指数', tooltip: '明るさを抵抗比から計算した独自の指数' },
    { value: 'RAW', label: 'センサー値', tooltip: 'センサーが読み取ったアナログ値' },
    { value: 'PERCENT', label: '割合', tooltip: '明るさを0〜100の割合で表した数値 (%)' },
];

export const AMMONIA_TYPE_OPTIONS = [
    { value: 'RAW', label: 'センサー値', tooltip: 'センサーが読み取ったアナログ値' },
    { value: 'PPM', label: '空気中アンモニア濃度', tooltip: '空気中のアンモニア濃度 (ppm)' },
];

export const ALCOHOL_TYPE_OPTIONS = [
    { value: 'RAW', label: 'センサー値', tooltip: 'センサーが読み取ったアナログ値' },
    { value: 'BREATH', label: '呼気中アルコール濃度', tooltip: '呼気中のアルコール濃度 (mg/L)' },
    { value: 'BLOOD', label: '血中アルコール濃度', tooltip: '血中のアルコール濃度の目安 (mg/L)' },
];

export const percentHelperCode = `int _sbeGetPercent(int pinNumber, int res) {
  return (int)(analogRead(pinNumber) / (float)res * 100);
}\n`;

let _used = false;

export function percentUsed(): boolean {
    return _used;
}

export function resetPercent(): void {
    _used = false;
}

export function markPercentUsed(): void {
    _used = true;
}
